import React, { Component } from 'react';
import BreadCrumb from '../../Common/BreadCrumb';
import HTMLFlipBook from 'react-pageflip';
import UserVerification from './UserVerification';
import { compose, branch, withProps } from 'recompose';
import { connectUserDetail } from '../../Auth/UserDetailManager';
import { HTMLTrans } from '../../Common/Translations';
import { isMobile as isMobileDevice } from 'react-device-detect';
import { withEphotobookContentData } from '../../Common/Providers/EPhotobookApi';
import { Link } from 'react-router';
import { FRONT_COVER, INNER_FRONT_COVER, BACK_COVER, INNER_BACK_COVER, WHITE_BG, VIEWER_TYPE_OWNER, VIEWER_TYPE_VISITOR, PUBLIC } from './Constants';
import EPhotobookBuyThis from './EPhotobookBuyThis';
import EPhotobookPublicShareLink from './EPhotobookPublicShareLink';
import { withDataLayerEPhotobookPreviewPush } from '../../Common/GTM/withDataLayerEPhotobookPreview';
import { connectUserHeaderinfo } from '../../Auth/WithUserHeaderInfo';
import { willRequireLogin } from '../../Auth';

export const mappedFilenames = (filenames) => filenames.map(filename => {
  let index;
  switch (filename) {
    case FRONT_COVER:
      index = 0;
      break;
    case INNER_FRONT_COVER:
      index = 1;
      break;
    case INNER_BACK_COVER:
      index = 3;
      break;
    case BACK_COVER:
      index = 4;
      break;
    default:
      index = 2;
  }
  return {
    value: filename,
    index
  };
});

const processSortedFiles = (files, condition) => {
  if (condition && files.length % 2 != 0) {
    files.splice(-2, 0, WHITE_BG);
  } else if (files.length % 2 != 0) {
    files.splice(-1, 0, WHITE_BG);
  }

  return files;
};

export const removeUnwantedPage = (sortedFiles, hasCover, endPaper) => {
  const covers = [FRONT_COVER, BACK_COVER];
  const innerCovers = [INNER_FRONT_COVER, INNER_BACK_COVER];

  if (hasCover && !endPaper) {
    sortedFiles = sortedFiles.filter(item => !innerCovers.includes(item));
  } else if (!hasCover && endPaper) {
      sortedFiles = sortedFiles.filter(item => !covers.includes(item));
  } else if (!hasCover && !endPaper) {
      return sortedFiles = sortedFiles.filter(item => !covers.includes(item) && !innerCovers.includes(item));
  }

  return processSortedFiles(sortedFiles, (hasCover && endPaper));
};


class FlipBook extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      totalPage: 0,
    };

    this.updateOrientation = this.updateOrientation.bind(this);
  }

  nextButtonClick = () => {
    this.pageFlip.getPageFlip().flipNext();
  };

  prevButtonClick = () => {
    this.pageFlip.getPageFlip().flipPrev();
  };

  onPage = (e) => {
    this.setState({
      page: e.data,
    });
  };

  updateOrientation() {
    if (this.pageFlip !== undefined) {
      this.pageFlip
        .getPageFlip()
        .update();
    }
  }

  componentDidMount() {
    const { dataLayerEPhotobookPreviewPush, ephotobookDetails: { isOwner = false } = {} } = this.props;
    if (this.pageFlip !== undefined) {
      this.setState({
        totalPage: this.pageFlip.getPageFlip().getPageCount()
      });

      dataLayerEPhotobookPreviewPush({
        ephotobookPreviewViewerType: isOwner ?
          VIEWER_TYPE_OWNER : VIEWER_TYPE_VISITOR
      });
    }

    window.addEventListener('resize', this.updateOrientation);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateOrientation);
  }

  render() {
    const {
      tRoute,
      t,
      ephotobookDetails: {
        imageUrl: imgUrl,
        content: {
          hasCover = false,
          endPaper = false,
          resolutions: contentResolution = [],
          image: {
            basePath: imageBasePath = {},
            filenames: filename = [],
          } = {},
          size: contentSize,
        } = {},
        owner: {
          name: ownerName,
        },
        isOwner = false,
        title = '',
      } = {},
      isMobile = false
    } = this.props;
    const resolution = (isMobile) ? Math.min.apply(null, contentResolution) : Math.max.apply(null, contentResolution);
    const width = contentSize.pages.width.px[resolution];
    const height = contentSize.pages.height.px[resolution];
    const basePath = imageBasePath[resolution];
    const sortedFile = mappedFilenames(filename)
      .sort(({ index: indexA }, { index: indexB }) => indexA - indexB)
      .map(({ value }) => (value));
    const finalBooks = removeUnwantedPage(sortedFile, hasCover, endPaper);

    return (
      <div className="container px-0">
        {(isOwner) &&
        <label className="mmm__label mmm__label--back-nav" htmlFor="sub-1">
          <span className="mmm__arrow mmm__arrow--left"><i className="fa fa-chevron-left"/></span>
          <Link href={tRoute('/account/dashboard/ephotobook')}>
            <HTMLTrans id="ephotobook.link_go_back">Go back to Share It</HTMLTrans>
          </Link>
        </label>
        }
        <div className="container my-5">
          <div className='container-fluid'>
            <div className="row justify-content-center text-center">
              <h4>{title}</h4><br/>
            </div>
            {!(isOwner) &&
            <div className="row justify-content-center text-center">
              <h5>By {ownerName}</h5>
            </div>
            }
            <div className="row justify-content-center">
              <HTMLFlipBook width={width}
                            height={height}
                            showCover={hasCover}
                            size='stretch'
                            minWidth={315}
                            maxWidth={1000}
                            minHeight={400}
                            maxHeight={1533}
                            maxShadowOpacity={0.5}
                            mobileScrollSupport={true}
                            onFlip={this.onPage}
                            ref={(el) => (this.pageFlip = el)}>
                {finalBooks.map((name, index) => (
                  <div className="demoPage" key={index}>
                    {name === WHITE_BG ?
                      <img className='img-ephotobook' src='/img/flipbook/white-bg.jpg'/> :
                      <img className='img-ephotobook' src={`${imgUrl}${basePath}/${name}`}/>
                    }
                  </div>
                ))}
              </HTMLFlipBook>
            </div>
            <div className="row mt-3 justify-content-between">
              <span className="flipbook-page-arrow"><i className="fa fa-chevron-left" onClick={this.prevButtonClick}></i></span>
              <span className="flipbook-page-text">{(this.state.page) + 1} / {this.state.totalPage}</span>
              <span className="flipbook-page-arrow"><i className="fa fa-chevron-right" onClick={this.nextButtonClick}></i></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const BuyAndShareComponent = ({ ephotobookDetails, t, isLoggedIn }) => {
  const {
    accessType: {
      code = ''
    } = {},
    content: {
      title = ''
    } = {},
    url: {
      file = '',
      link = ''
    } = {},
    previewImg = '',
    purchasable = true
  } = ephotobookDetails;

  return (
    <div>
      {purchasable && <EPhotobookBuyThis file={file} page="ephotobook" isLoggedIn={isLoggedIn} />}
      { code === PUBLIC &&
        <div className="d-flex pt-3 pb-5 justify-content-center">
          <EPhotobookPublicShareLink t={t} link={link} title={title} previewImg={previewImg}/>
        </div>
      }
    </div>
  );
}

const ErrorMessage = ({ children }) => (
  <div className="container my-3">
    <h4 className="font-weight-bold">
      <HTMLTrans id="ephotobook.error_message_title">Oh no!</HTMLTrans>
    </h4>
    <p className="error-message__content">
      {children || <HTMLTrans id="ephotobook.error_message_default">
        Something went wrong, please reload again.
      </HTMLTrans>}
    </p>
  </div>
);

const FlipBookContainer = (props) => {
  const {
    ephotobookDetails = {},
    errorMessage,
    isMobile,
    userDetail,
    dataLayerEPhotobookPreviewPush,
    t,
    userHeaderInfo
  } = props;
  const {
    isOwner = false,
    userVerification: {
      status: isVerified = false
    } = {}
  } = ephotobookDetails;

  return (
    <div>
      <BreadCrumb {...props}/>
      {errorMessage
        ? <ErrorMessage>{errorMessage}</ErrorMessage>
        : <div>
          {!isOwner && !isVerified
            ? <UserVerification
              ephotobookDetails={ephotobookDetails}
              userDetail={userDetail}
              t={t}
            />
            :
            <div>
              <div className="bg-gray-lighten-3 p-3 p-lg-6">
                <FlipBook
                  ephotobookDetails={ephotobookDetails}
                  isMobile={isMobile}
                  tRoute={props.tRoute}
                  t={t}
                  dataLayerEPhotobookPreviewPush={dataLayerEPhotobookPreviewPush}
                />
              </div>
              <BuyAndShareComponent
                ephotobookDetails={ephotobookDetails}
                t={t}
                isLoggedIn={userHeaderInfo.isLoggedIn}
              />
            </div>
          }
        </div>}
    </div>
  );
};

const isLoginRequired = ({ ephotobookDetails }) => (
  ephotobookDetails.accessType ? ephotobookDetails.accessType.code !== 'public' : true
);

const enhance = compose(
  connectUserHeaderinfo,
  withEphotobookContentData,
  withDataLayerEPhotobookPreviewPush,
  withProps(( props ) => ({
    isMobile: isMobileDevice,
    shouldRequireLogin: isLoginRequired(props)
  })),
  branch((props) => props.shouldRequireLogin,
    willRequireLogin
  ),
  connectUserDetail
);

export default enhance(FlipBookContainer);
export const undecorated = FlipBookContainer;



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/FlipBookContainer.js